import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { timer } from 'rxjs';
import { AuthService } from 'src/app/api/auth.service';
import { ChartLayoutService } from 'src/app/services/chart-layout.service';

const RECURRING_BUY_BANNER_SEEN_KEY = 'recurring_buy_banner_seen';

@Component({
    selector: 'auth-logout',
    templateUrl: './logout.component.html',
    styleUrls: ['./logout.component.scss'],
    standalone: false
})
export class LogoutComponent implements OnInit {

  constructor(
    private router: Router,
    private auth: AuthService
  ) { }

  ngOnInit() {
    this.auth.logout();

    let proChartLayoutData = window.localStorage.getItem(ChartLayoutService.CHART_LAYOUT_DATA_KEY);
    let recurringBuyBannerSeen = window.localStorage.getItem(RECURRING_BUY_BANNER_SEEN_KEY);

    // Clear local storage
    window.localStorage.clear();

    localStorage.setItem(ChartLayoutService.CHART_LAYOUT_DATA_KEY, proChartLayoutData);
    if (recurringBuyBannerSeen !== null) {
      localStorage.setItem(RECURRING_BUY_BANNER_SEEN_KEY, recurringBuyBannerSeen);
    }

    timer(1000).subscribe(() => {
      this.router.navigate(['/home']);
    });
  }

}
